import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import interceptor from './service/interceptor';
import App from './App';
import {SnackbarProvider} from 'notistack';
import reportWebVitals from './reportWebVitals';
import "primereact/resources/themes/saga-orange/theme.css"      
import { PrimeReactProvider } from 'primereact/api';
import { store } from './features/store';
import { Provider } from 'react-redux';   
await interceptor()   
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PrimeReactProvider>
    <Provider store={store}>
    <SnackbarProvider>
     <App />
     </SnackbarProvider>
    </Provider>
    </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
